import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/home/Home';
import { RandomMapTheme } from './pages/rmt/RandomMapTheme';
import { SwampTavern } from './pages/swamptavern/SwampTavern';
import { EventResultPage } from './pages/swamptavern/EventResultPage';

function App() {
  return (
     <BrowserRouter>
       <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/random-map-theme" element={<RandomMapTheme />} />
         <Route path="/swamp" element={<SwampTavern />} />
         <Route path="/swamp/event/:eventId" element={<EventResultPage />} />
       </Routes>
     </BrowserRouter>
  );
}

export default App;